/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card-choice',
  templateUrl: './card-choice.component.html',
  styleUrls: ['./card-choice.component.scss']
})
export class CardChoiceComponent {
  /**
   * lista dettagli
   */
  @Input() details: KeyValue<string, string | number>[] = [];

  /**
   * icona
   */
  @Input() icon: string;

  /**
   * evento emesso alla scelta dell'item
   */
  @Output() itemChoice = new EventEmitter<void>();

  /**
   * evento emesso al click dell'item
   */
  onClick(): void {
    this.itemChoice.emit();
  }
}
